import Fondo from "../assets/fondoOpiniones.png"

const Opiniones = () => {
    return (
        <div
            className="w-full h-screen bg-cover bg-center flex items-center justify-start"
            style={{ backgroundImage: `url(${Fondo})` }}
        >
            <div className="w-full text-white px-4 md:px-44 text-center grid grid-cols-1 gap-4 md:gap-24">
                <div>
                    <h2 className="text-4xl text-white">Nuestros Clientes Opinan</h2>
                </div>
                <div>
                    <p>Martes 25 de marzo, 2022</p>
                    <h2 className="text-2xl text-orange-500 font-bold">" La asesoría contable que me brindaron me fue de gran ayuda en el cierre del ejercicio fiscal de mi empresa. "</h2>
                </div>
                <div>
                    <p className="text-lg">Aldo López Corona</p>
                    <p className="text-lg">Gerente regional, Puebla, Pue</p>
                </div>
            </div>
        </div>
    );
};

export default Opiniones;